// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".v-input--selection-controls[data-v-af69a7cc]{margin-top:0}", "",{"version":3,"sources":["/Users/niwashouta/projects/kgi_sfa/app/javascript/erp_src/view/logistics/components/AnswerValueHistory.vue"],"names":[],"mappings":"AACA,8CACC,YAAA","file":"AnswerValueHistory.vue","sourcesContent":["\n.v-input--selection-controls {\n\tmargin-top: 0;\n}\n"]}]);
// Exports
module.exports = exports;
